function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_hourglass"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m8 4h8v2h-4c-.552 0-1 .447-1 1s.448 1 1 1h3.858c-.176.685-.518 1.319-1.029 1.837-.389.393-.385 1.026.008 1.414.195.193.449.289.703.289.258 0 .516-.099.711-.297 1.128-1.14 1.749-2.647 1.749-4.243v-3c.552 0 1-.447 1-1s-.448-1-1-1h-1-9c-.552 0-1 .447-1 1s.448 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.707 20.293-18-18c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l3.729 3.729c.138 1.904 1.163 3.564 2.668 4.564-1.619 1.075-2.69 2.914-2.69 5v3c-.552 0-1 .447-1 1s.448 1 1 1h12c.552 0 1-.447 1-1s-.448-1-1-1v-.586l2.293 2.293c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm-7.121-4.293h-6.444c.416-1.602 1.793-2.802 3.482-2.962zm-6.586 4v-2h8v2z"
})));

var Svg073Hourglass = function Svg073Hourglass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg073Hourglass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/073-hourglass.062f5451.svg";
export { ForwardRef as ReactComponent };